import api from 'config/axiosConfig';

export const getCategoryTable = id => {
  return api.get(`api/categories/${id}/table`);
};
